import { render, staticRenderFns } from "./SetupStepSupport.vue?vue&type=template&id=7990ba16&scoped=true&"
import script from "./SetupStepSupport.vue?vue&type=script&lang=js&"
export * from "./SetupStepSupport.vue?vue&type=script&lang=js&"
import style0 from "./SetupStepSupport.vue?vue&type=style&index=0&id=7990ba16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990ba16",
  null
  
)

export default component.exports